/* Copyright (c) 2026 Goffy. All Rights Reserved. */

:root {
  --goffy-date-bg: #1e4f0e;
  --goffy-date-panel: #e4ebe5;
  --goffy-date-border: #2a7742;
  --goffy-date-text: #d8f3df;
  --goffy-date-muted: #3a403d;
  --goffy-date-accent: #2f8a4e;
  --goffy-date-accent-strong: #2f8a4e;
}

.goffy-date-picker-wrapper {
  width: 100%;
}

.goffy-date-picker {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--goffy-date-border);
  padding: 8px 10px;
  background: var(--goffy-date-bg);
  color: var(--goffy-date-text);
  font-size: 14px;
}

.react-datepicker {
  background-color: var(--goffy-date-panel);
  border: 1px solid var(--goffy-date-border);
  color: var(--goffy-date-text);
  font-family: inherit;
}

.react-datepicker__header {
  background-color: var(--goffy-date-panel);
  border-bottom: 1px solid var(--goffy-date-border);
}

.react-datepicker__current-month,
.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: var(--goffy-date-text);
}

.react-datepicker__day--outside-month {
  color: var(--goffy-date-muted);
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  background-color: rgba(47, 138, 78, 0.16);
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: var(--goffy-date-accent-strong);
  color: #d8f3df;
  font-weight: 700;
  box-shadow: 0 0 0 2px rgba(47, 138, 78, 0.4);
}

.react-datepicker__navigation-icon::before {
  border-color: var(--goffy-date-text);
}

.react-datepicker__triangle::before,
.react-datepicker__triangle::after {
  border-bottom-color: var(--goffy-date-panel);
}

/* Inline datepicker doesn't use portal/poppers. */
